import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { ScrollAdapterComponent } from '@frontend/sports/common/core/feature/scroll-adapter';
import { LinkDirective, SportsThemedPillsDirective } from '@frontend/sports/common/ui/sports-themed-pills';
import { DsArrow } from '@frontend/ui/arrow';
import { DsNotificationBubble } from '@frontend/ui/notification-bubble';
import { DsPill } from '@frontend/ui/pill';
import { DsTabsModule } from '@frontend/ui/tabsgroup';
import { MenuItemActionDirective, MenuItemBadgeDirective, MenuItemComponent, MenuItemTrackingDirective } from '@frontend/vanilla/features/menus';
import { SpeculativeLinkDirective } from '@frontend/vanilla/features/speculative-link';
import { IconCustomComponent } from '@frontend/vanilla/shared/icons';

import { DirectivesModule } from '../directives/directives.module';
import { NavigationCoreModule } from '../navigation-core/navigation-core.module';
import { LaunchDarklyTrackerDirective } from './launch-darkly-tracker.directive';
import { SportNavigationComponent } from './sport-navigation/sport-navigation.component';
import { MainItemsComponent } from './top-navigation/main-items.component';
import { NavigationComponent } from './top-navigation/navigation.component';

@NgModule({
    imports: [
        CommonModule,
        DirectivesModule,
        SpeculativeLinkDirective,
        MenuItemComponent,
        MenuItemBadgeDirective,
        NavigationCoreModule,
        ScrollAdapterComponent,
        DsTabsModule,
        IconCustomComponent,
        DsNotificationBubble,
        LinkDirective,
        DsPill,
        MenuItemActionDirective,
        MenuItemTrackingDirective,
        SportsThemedPillsDirective,
        LaunchDarklyTrackerDirective,
        DsArrow,
    ],
    declarations: [NavigationComponent, SportNavigationComponent, MainItemsComponent],
})
export class NavigationModule {}
